module.exports = __webpack_public_path__ + "static/media/image4.a4d7630b.jpg";